export async function ptlPrepareOrdersUseCase(order_ids, shipmentRepository) {
    
    const result = await shipmentRepository.ptl_prepare_orders(order_ids);
    
    result.data.success.arguments.data.products.forEach(x => {        
        x = new shipmentRepository.model_ptl_product(x);
    
        if (!x.isValid()) {
            throw new Error("Producto ptl inválido");
        }
    })

    return result.data.success.arguments.data;
}